const text = (value, max, label) => {
  if (typeof value !== 'string' || !value.trim() || value.length > max) throw new Error(`Invalid ${label}.`);
  return value.trim();
};
export function normalizeComments(value = []) {
  if (!Array.isArray(value) || value.length > 2000) throw new Error('Too many comment threads.');
  const ids = new Set();
  const id = value => {
    const result = text(value, 120, 'comment ID');
    if (ids.has(result)) throw new Error('Duplicate comment ID.');
    ids.add(result);
    return result;
  };
  return value.map(thread => ({
    id: id(thread.id),
    nodeId: thread.nodeId === null ? null : text(thread.nodeId, 200, 'comment anchor'),
    resolved: Boolean(thread.resolved),
    messages: (() => {
      if (!Array.isArray(thread.messages) || !thread.messages.length || thread.messages.length > 500) throw new Error('Invalid comment replies.');
      return thread.messages.map(message => ({
        id: id(message.id), author: text(message.author, 80, 'display name'),
        body: text(message.body, 10000, 'comment'),
        createdAt: text(message.createdAt, 40, 'comment date'),
      }));
    })(),
  }));
}
export function commentMessage(author, body) {
  return { id: crypto.randomUUID(), author: text(author, 80, 'display name'), body: text(body, 10000, 'comment'), createdAt: new Date().toISOString() };
}
